var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReviewBackgroundTablet(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 797,
    height: 598,
    viewBox: "0 0 797 598",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_756_6170)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 41,
    width: 635,
    height: 436,
    rx: 80.3951,
    fill: "#FFE3B0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M213.34 69.6045C213.33 71.4079 214.858 72.819 216.754 72.7564C218.649 72.6937 220.194 71.181 220.204 69.3776C220.215 67.5742 218.686 66.1631 216.791 66.2258C214.895 66.2884 213.351 67.8011 213.34 69.6045Z",
    stroke: "#8F6F6F",
    strokeWidth: 3.7049
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M139.386 230.934C139.379 232.207 140.458 233.203 141.796 233.159C143.134 233.115 144.224 232.047 144.232 230.774C144.239 229.501 143.16 228.505 141.822 228.549C140.484 228.593 139.393 229.661 139.386 230.934Z",
    stroke: "#8F6F6F",
    strokeWidth: 3.7049
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M170.684 137.611C170.674 139.414 172.202 140.825 174.098 140.762C175.993 140.7 177.538 139.187 177.548 137.384C177.558 135.58 176.03 134.169 174.135 134.232C172.239 134.295 170.694 135.807 170.684 137.611Z",
    stroke: "#8F6F6F",
    strokeWidth: 3.7049
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M204.341 142.915C204.336 143.763 205.056 144.427 205.948 144.398C206.84 144.368 207.567 143.657 207.572 142.808C207.577 141.96 206.857 141.296 205.965 141.325C205.073 141.355 204.346 142.066 204.341 142.915Z",
    stroke: "#8F6F6F",
    strokeWidth: 3.7049
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M346.09 72.5965C346.086 73.445 346.805 74.1089 347.697 74.0794C348.589 74.0499 349.316 73.3382 349.321 72.4897C349.326 71.6412 348.607 70.9773 347.714 71.0068C346.822 71.0363 346.095 71.748 346.09 72.5965Z",
    stroke: "#8F6F6F",
    strokeWidth: 3.7049
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M114.464 159.178C114.454 160.982 115.982 162.393 117.878 162.33C119.773 162.268 121.318 160.755 121.328 158.952C121.338 157.148 119.81 155.737 117.915 155.8C116.019 155.862 114.474 157.375 114.464 159.178Z",
    stroke: "#8F6F6F",
    strokeWidth: 3.7049
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M213.228 97.5769L205.246 104.752",
    stroke: "#8F6F6F",
    strokeWidth: 3.7049
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M399.541 98.9205L393.525 92.4352",
    stroke: "#8F6F6F",
    strokeWidth: 3.7049
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M135.601 82.9279L124.749 78.8137",
    stroke: "#8F6F6F",
    strokeWidth: 3.7049
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M108.672 280.788L99.0226 287.456",
    stroke: "#8F6F6F",
    strokeWidth: 3.7049
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M302.965 72.4692L300.536 81.164",
    stroke: "#8F6F6F",
    strokeWidth: 3.7049
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M178.668 207.234L170.876 201.207",
    stroke: "#8F6F6F",
    strokeWidth: 3.7049
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M589.86 458.378C589.838 456.731 588.415 455.471 586.682 455.564C584.949 455.658 583.562 457.07 583.584 458.717C583.607 460.365 585.03 461.625 586.763 461.531C588.496 461.437 589.883 460.026 589.86 458.378Z",
    stroke: "#8F6F6F",
    strokeWidth: 3.7049
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M654.536 309.471C654.52 308.307 653.515 307.418 652.292 307.484C651.069 307.55 650.09 308.547 650.106 309.71C650.121 310.873 651.126 311.763 652.349 311.697C653.573 311.631 654.552 310.634 654.536 309.471Z",
    stroke: "#8F6F6F",
    strokeWidth: 3.7049
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M468.394 458.077C468.384 457.302 467.714 456.708 466.899 456.753C466.083 456.797 465.431 457.461 465.441 458.237C465.452 459.013 466.121 459.606 466.937 459.562C467.752 459.518 468.405 458.853 468.394 458.077Z",
    stroke: "#8F6F6F",
    strokeWidth: 3.7049
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M678.652 374.641C678.63 372.993 677.207 371.733 675.473 371.827C673.74 371.92 672.354 373.332 672.376 374.98C672.398 376.627 673.822 377.887 675.555 377.793C677.288 377.7 678.674 376.288 678.652 374.641Z",
    stroke: "#8F6F6F",
    strokeWidth: 3.7049
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M589.445 432.794L596.62 426.084",
    stroke: "#8F6F6F",
    strokeWidth: 3.7049
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M419.024 434.989L424.646 440.802",
    stroke: "#8F6F6F",
    strokeWidth: 3.7049
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M660.714 444.772L670.715 448.328",
    stroke: "#8F6F6F",
    strokeWidth: 3.7049
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M681.71 263.313L690.419 257.036",
    stroke: "#8F6F6F",
    strokeWidth: 3.7049
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M507.833 457.404L509.904 449.408",
    stroke: "#8F6F6F",
    strokeWidth: 3.7049
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_756_6170",
    x: 0.604942,
    y: 0.802471,
    width: 795.79,
    height: 596.79,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 40.1975
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40.1975
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_756_6170"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_756_6170",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewBackgroundTablet);
export default __webpack_public_path__ + "static/media/ReviewBackgroundTablet.0293bd57be1e0811cbb835ab697bf844.svg";
export { ForwardRef as ReactComponent };